import { Avatar, Box, Button, Menu, MenuItem } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

/* ---------- Direction C tokens (styling only) ---------- */
const FONT = "'Plus Jakarta Sans', system-ui, -apple-system, sans-serif";
const MONO = "'IBM Plex Mono', ui-monospace, monospace";
const INK = "#0F1B2A";
const INK_2 = "#3D4C60";
const LINE = "#E4E9EF";

function stringAvatar(name) {
  const parts = name.trim().split(" ");
  if (parts.length === 1) {
    return {
      children: parts[0][0].toUpperCase(),
    };
  } else {
    return {
      children: `${parts[0][0]}${parts[1][0]}`.toUpperCase(),
    };
  }
}

const SuperadminNavbar = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const storedUser = JSON.parse(localStorage.getItem("user"));

  const handleAvatarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };
  return (
    <Box
      sx={{
        background: "#ffffff",
        borderBottom: `1px solid ${LINE}`,
        position: "sticky",
        top: 0,
        zIndex: 20,
        fontFamily: FONT,
        color: INK,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 2,
          minHeight: 56,
          px: { xs: 2, sm: 3, md: 4 },
          maxWidth: 1400,
          mx: "auto",
          boxSizing: "border-box",
        }}
      >
        {/* <div>Logo</div> */}
        <Box
          component="span"
          sx={{
            display: "inline-flex",
            alignItems: "center",
            height: 28,
            px: 1.25,
            borderRadius: "999px",
            background: "#EFEDFB",
            border: "1px solid #D3D0F2",
            color: "#4A3FBF",
            fontFamily: FONT,
            fontSize: 11,
            fontWeight: 700,
            letterSpacing: "0.08em",
            textTransform: "uppercase",
            whiteSpace: "nowrap",
          }}
        >
          Superadmin
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", columnGap: { xs: 1.5, sm: 2.5 } }}>
            <Button
              className="btn-outlined"
              sx={{
                height: 36,
                padding: "0 16px !important",
                borderRadius: "9px !important",
                border: "1px solid #D5DEE7 !important",
                background: "#FFFFFF !important",
                color: `${INK} !important`,
                fontFamily: FONT,
                fontSize: 13.5,
                fontWeight: 600,
                textTransform: "none",
                boxShadow: "none",
                whiteSpace: "nowrap",
                "&:hover": { background: "#F4F7FA !important" },
              }}
              onClick={() => navigate("/superadmin-dashboard")}
            >
              Dashboard
            </Button>
          <Box
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: 1.25,
              fontFamily: MONO,
              fontSize: 12.5,
              fontWeight: 600,
              color: INK_2,
              whiteSpace: "nowrap",
            }}
          >
            <Box component="span" sx={{ display: { xs: "none", sm: "inline" } }}>
              {storedUser.username}
            </Box>
            <Avatar
              {...stringAvatar(`Super Admin`)}
              onClick={handleAvatarClick}
              sx={{
                cursor: "pointer",
                width: 32,
                height: 32,
                background: INK,
                color: "#FFFFFF",
                fontFamily: MONO,
                fontSize: 11.5,
                fontWeight: 600,
                transition: "box-shadow .15s",
                boxShadow: open ? "0 0 0 3px #C9DEF3" : "none",
                "&:hover": { boxShadow: "0 0 0 3px #EAF2FB" },
              }}
            />
            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              sx={{
                "& .MuiPaper-root": {
                  mt: 1,
                  minWidth: 180,
                  borderRadius: "12px",
                  border: `1px solid ${LINE}`,
                  boxShadow: "0 16px 36px -12px rgba(15,27,42,0.24)",
                },
                "& .MuiList-root": { p: 0.75 },
                "& .MuiMenuItem-root": {
                  fontFamily: FONT,
                  fontSize: 13.5,
                  fontWeight: 700,
                  color: "#A6342A",
                  borderRadius: "8px",
                  minHeight: 36,
                  px: 1.25,
                  "&:hover": { background: "#FBEDEB" },
                },
              }}
            >
              <MenuItem onClick={handleLogout}>Logout</MenuItem>
            </Menu>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default SuperadminNavbar;
